export const TaskboardRoutes = {
  path: 'taskboard',
  lazy: () => import('pages/taskboard'),
  handle: { name: 'Taskboard', category: 'Taskboard' },
};
